/**
 * Labstep
 *
 * @module components/Log/Filter/Group/Select
 * @desc Search group to filter Logs
 */

import { FilterEntityContainer as FilterEntity } from 'labstep-web/components/Filter/Entity';
import { Container } from 'labstep-web/components/Layout/Container';
import { LayoutContainerActionButtons } from 'labstep-web/components/Layout/Container/ActionButtons';
import { ICONS } from 'labstep-web/constants/icons';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import { Group } from 'labstep-web/models/group.model';
import type React from 'react';
import { useState } from 'react';
import type {
  GroupChildrenProps,
  LogFilterGroupSelectProps,
} from './types';

export const LogFilterGroupSelect: React.FC<
  LogFilterGroupSelectProps
> = ({ setParams, searchParams }) => {
  const children = (
    <EntityReadEntityContainer
      entityName={Group.entityName}
      id={(searchParams.group_id as number) || 'random'}
    >
      {({ entity: group }: GroupChildrenProps) => (
        <>
          <b>Workspace</b>
          <SearchSelect
            menuPlacement="top"
            entityName={Group.entityName}
            onChange={(selectedOption) => {
              if (!selectedOption) {
                setParams({
                  group_id: undefined,
                });
              } else {
                setParams({
                  group_id: selectedOption.id,
                });
              }
            }}
            value={group}
            usePartialSerializer
          />
        </>
      )}
    </EntityReadEntityContainer>
  );

  return (
    <Modal
      header="Filter by Workspace"
      content={({ toggleModal }) => (
        <div>
          <Container>{children}</Container>
          <LayoutContainerActionButtons>
            <ActionComponent
              type="button"
              text="Done"
              onClick={toggleModal}
            />
          </LayoutContainerActionButtons>
        </div>
      )}
      viewComponent={({ toggleModal }) => (
        <ActionComponent
          type="option"
          icon={ICONS.group.primary}
          text="Workspace"
          onClick={toggleModal}
        />
      )}
    />
  );
};

export const LogFilterGroupSelectContainer: React.FC<
  LogFilterGroupSelectProps
> = (props) => {
  const { searchParams, setParams, ...rest } = props;
  const [shouldRenderWithFilter] = useState(
    'group_id' in searchParams,
  );

  const children = (
    <LogFilterGroupSelect
      setParams={setParams}
      searchParams={searchParams}
      {...rest}
    />
  );

  if (!shouldRenderWithFilter) {
    return children;
  }

  let entityName;
  let searchParamKey;

  if (searchParams.group_id) {
    entityName = Group.entityName;
    searchParamKey = 'group_id';
  } else {
    return children;
  }

  return (
    <FilterEntity
      entityName={entityName}
      searchParamKey={searchParamKey}
      searchParams={searchParams}
    >
      {() => children}
    </FilterEntity>
  );
};
